module.exports = __webpack_public_path__ + "static/learn-324b03d349912f572a46870b880f54e2.png";